import qs from 'qs';
import request from '../utils/request';

// 添加站点
export const createVoice = (data) => request({
  url: '/admin/voice',
  method: 'post',
  data,
});
  // 站点列表
export const voiceList = (param) => request(`/admin/voice?${qs.stringify(param)}`);
// 站点详情
export const voiceDetail = (id) => request(`/admin/voice/${id}`);
